import { CertificationRecord } from '__generated__/graphql';
import { useApolloPaging } from 'hooks';
import { isNil } from 'lodash';
import { DateTime } from 'luxon';
import { useCallback } from 'react';
import ICursorable from 'types/Cursorable';
import { CERTIFICATION_RECORDS_QUERY } from './useCertificationStatusReportActiveData';

export function useCertificationRecordData() {
  const { getAll } = useApolloPaging();

  return useCallback(async (ids: string[]) => {
    const getCertificationRecords = getAll<CertificationRecord & ICursorable>('certificationRecords', {
      query: CERTIFICATION_RECORDS_QUERY,
      variables: {
        first: 500,
        filter: {
          memberId: { contains: ids },
          deletedOn: { isNull: true },
        },
      },
      fetchPolicy: 'network-only',
    });
    return await Promise.all([getCertificationRecords]).then((queryResults) => {
      const [results] = queryResults;
      const data = results.filter((record: CertificationRecord) => {
        if (isNil(record.expiresOn) || DateTime.fromISO(record.expiresOn).toISODate() > DateTime.now().toISODate()) {
          return record;
        }
      });
      return data;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
